module.exports = ".container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n\n.user-list {\n  -webkit-box-flex: 2;\n      -ms-flex: 2;\n          flex: 2;\n  margin: 10px; }\n\n.detail-info {\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  margin: 10px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/users/users/users.component.scss
// module id = ./src/app/users/users/users.component.scss
// module chunks = main